import { useState } from 'react';

const STORAGE_KEY = 'rps-tournament-player';

// Some browsers (privacy-focused ones, certain private-browsing modes) throw
// on localStorage access instead of just no-op'ing. Read/write defensively
// so those users still get a working session — it just won't survive a
// page refresh.
function readStoredPlayer() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

function writeStoredPlayer(player) {
  try {
    if (player) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(player));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage unavailable/blocked — nothing to persist to, carry on in memory.
  }
}

// Tracks the current browser's player identity ({ id, name, tournamentId })
// in localStorage so a page refresh doesn't create a duplicate join.
export function usePlayerIdentity() {
  const [me, setMeState] = useState(readStoredPlayer);

  const setMe = (player) => {
    writeStoredPlayer(player);
    setMeState(player);
  };

  return [me, setMe];
}
